import { CartItemTypeRes } from "../types/cartItemType";

export const sumCartItemMrpPrice = (cartItems: CartItemTypeRes[]) => {
  return cartItems.reduce((acc, item) => {
    if (!item || typeof item.mrpPrice === "undefined") {
      console.error("Invalid cart item:", item);
      return acc;
    }

    return acc + item.mrpPrice * item.quantity;
  }, 0);
};

export const sumCartItemSellingPrice = (cartItems: CartItemTypeRes[]) => {
  return cartItems.reduce((acc, item) => {
    if (!item || typeof item.sellingPrice === "undefined") {
      console.error("Invalid cart item:", item);
      return acc;
    }

    return acc + item.sellingPrice * item.quantity;
  }, 0);
};